export const arrayBufferToBase64 = (buffer: ArrayBuffer): Promise<string> => {
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => resolve(reader.result as string)
		reader.onerror = reject
		reader.readAsDataURL(new Blob([buffer], { type: 'image/jpeg' }))
	})
}
